import React from 'react';

import {
  GetMyDetailsQueryUser,
  useGetMyDetails,
} from '../data/useGetMyDetails';

export const withCurrentUser =
  <P extends React.PropsWithChildren<{ currentUser: GetMyDetailsQueryUser }>>(
    Component: React.ComponentType<P>
  ): React.FC<Omit<P, 'currentUser'>> =>
  (props) => {
    const { data } = useGetMyDetails();
    return data ? <Component currentUser={data} {...(props as any)} /> : null;
  };
